"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = require("@/api/config");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ConfigExpress',
  data: function data() {
    return {
      dataForm: {
        litemall_express_freight_min: 0,
        litemall_express_freight_value: 0
      },
      rules: {
        litemall_express_freight_min: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }],
        litemall_express_freight_value: [{
          required: true,
          message: '不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      (0, _config.listExpress)().then(function (response) {
        _this.dataForm = response.data.data;
      });
    },
    cancel: function cancel() {
      this.init();
    },
    update: function update() {
      var _this2 = this;
      this.$refs['dataForm'].validate(function (valid) {
        if (!valid) {
          return false;
        }
        _this2.doUpdate();
      });
    },
    doUpdate: function doUpdate() {
      var _this3 = this;
      (0, _config.updateExpress)(this.dataForm).then(function (response) {
        _this3.$notify.success({
          title: '成功',
          message: '运费配置修改成功'
        });
      }).catch(function (response) {
        _this3.$notify.error({
          title: '失败',
          message: response.data.errmsg
        });
      });
    }
  }
};